export const DISPLAY_WIDTH: number = 110;
export const DISPLAY_HEIGHT: number = 40;

// Event Constants
export const TITLE_FINISHED: string = "title-finished";
export const PROGRESS_DIALOGUE: string = "progress-dialogue";
export const INTRO_FINISHED: string = "intro-finished";
export const CHAPTER_ONE_INTRO_FINISHED: string = "chapter-one-intro-finished";
export const CHAPTER_ONE_EXIT_INTERACTION: string = "chapter-one-exit-interaction";
export const CHAPTER_ONE_FINISHED: string = "chapter-one-finished";
export const START_CHAPTER_TWO_DIALOGUE: string = "start-chapter-two-dialogue";
export const CHAPTER_TWO_INTRO_FINISHED: string = "chapter-two-finished";
export const START_GAME: string = "start-game";
export const START_PLAYERS_TURN: string = "start-players-turn";
export const FINISHED_PLAYERS_TURN: string = "finished-players-turn";
export const DISPLAY_ZOOM_IN: string = "zoom-in";
export const DISPLAY_ZOOM_OUT: string = "zoom-out";
export const DISPLAY_TUTORIAL_MESSAGE: string = "disp-tut-msg";
export const USER_DISMISSED_TUTORIAL_MESSAGE: string = "usr-dismissed-tut-msg";
export const ITEM_INTERACTION_HAPPENED: string = "interaction-happened";
export const ITEM_ADDED_TO_INVENTORY: string = "item-added-to-inventory";
export const DISPLAY_INVENTORY_ZOOM_IN: string = "zoom-in-on-inventory";

// Game Constants
export const BACKGROUND_DEFAULT_COLOR: string = "#000";
export const FOREGROUND_DEFAULT_COLOR: string = "#FFF";
export const PLAYERS_DEFAULT_VISION: number = 5;
export const OPAQUE: boolean = false;
export const TRANSPARENT: boolean = true;
export const PASSABLE: boolean = true;
export const NOT_PASSABLE: boolean = false;
export const PERSISTENT_ACTOR: boolean = true;
export const DEFAULT_FONT_SIZE: number = 18;